import { useCallback } from 'react'

import { DateRange, DateRangeString, DayPickerRange } from 'Models'
import { registrationDateSelector } from 'ReduxStore/coreBackendUser'
import { useAppSelector } from 'ReduxStore/hooks'
import { currentProgramStartDateSelector, programsSelector } from 'ReduxStore/programs'
import { Utils } from 'Utils'

type CalculateRangeFn = (dateRange: DateRangeString, appliedRange: DayPickerRange) => DateRange | null

const useCalculateRange = (): CalculateRangeFn => {
  const registrationDate = useAppSelector(registrationDateSelector)
  const currentProgramStartDate = useAppSelector(currentProgramStartDateSelector)
  const programs = useAppSelector(programsSelector)

  return useCallback(
    (dateRange: DateRangeString, appliedRange: DayPickerRange): DateRange | null => {
      if (!registrationDate) {
        return null
      }

      const { from, to } = appliedRange

      switch (dateRange) {
        case 'CUSTOM':
          if (!from || !to) {
            return null
          }

          return { dateFrom: from, dateTo: to }
        case 'PROGRAMSTART':
          if (programs === null) {
            return null
          }

          return Utils.dateRangeFromString(dateRange, registrationDate, currentProgramStartDate)
        default:
          return Utils.dateRangeFromString(dateRange, registrationDate, currentProgramStartDate)
      }
    },
    [registrationDate, currentProgramStartDate, programs]
  )
}

export default useCalculateRange
